import { normalize, schema } from 'normalizr'
import { IMobilityOptionObject } from '../types'
import { serverApi } from '../utils/request'
import Paths from '../utils/paths'

const mobilityOptionsResponse = [
  {
    id: '1',
    name: 'Folding Wheelchair',
    category: 'Wheelchair',
    active: true
  },
  {
    id: '2',
    name: 'Non Folding Wheelchair',
    category: 'Wheelchair',
    active: true
  },
  {
    id: '3',
    name: 'Scooter',
    category: 'Wheelchair',
    active: false
  },
  {
    id: '4',
    name: 'Powerchair',
    category: 'Wheelchair',
    active: false
  },
  {
    id: '5',
    name: 'Folding Walker',
    category: 'Walker',
    active: false
  },
  {
    id: '6',
    name: 'Non Folding Walker',
    category: 'Walker',
    active: false
  }
]

const mobilityOptionsCategoriesResponse = [
  {
    id: '1',
    name: 'Walker'
  },
  {
    id: '2',
    name: 'Wheelchair'
  },
  {
    id: '3',
    name: 'Ambulatory'
  }
]

class MobilityOptionsService {
  private schemaMobilityOptionCategories = new schema.Entity('mobilityOptionCategories')
  private schemaMobilityOptionCategoriesResponse = [this.schemaMobilityOptionCategories]

  private schemaMobilityOptions = new schema.Entity('mobilityOptions')
  private schemaMobilityOptionsResponse = [this.schemaMobilityOptions]

  private schemaMobilityCategories = new schema.Entity('mobilityOptionsCategories', {
    mobilities: [this.schemaMobilityOptions]
  })
  private schemaMobilityCategoriesWithOptionsResponse = [this.schemaMobilityCategories]

  // TODO: Implement service
  public fetchMobilityOptions() {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(mobilityOptionsResponse)
      }, 100)
    })
  }

  // TODO: Implement service
  public searchMobilityOptions(query: string): any {
    return new Promise((resolve, reject) => {
      const str = new RegExp(query, 'i')
      const filtered = mobilityOptionsResponse.filter((mobilityOption: any) => {
        if (mobilityOption.name.match(str) || mobilityOption.category.match(str)) {
          return mobilityOption
        }
      })
      resolve(filtered)
    })
  }

  public getMobilityCategoriesWithOptions() {
    return serverApi.get(Paths.mobilityCategory.getAllWithMobilities).then(({ data }) => {
      const normalized = normalize(data, this.schemaMobilityCategoriesWithOptionsResponse)
      if (!normalized.entities) {
        return { mobilityOptions: {}, mobilityOptionsCategories: {} }
      }
      return normalized.entities
    })
  }

  public getMobilityOptions() {
    return serverApi.get(Paths.mobility.getAll).then(({ data }) => {
      const normalized = normalize(data, this.schemaMobilityOptionsResponse)
      if (!normalized.entities || !normalized.entities.mobilityOptions) {
        return {}
      }
      return normalized.entities.mobilityOptions
    })
  }

  public getMobilityOptionCategories() {
    return serverApi.get(Paths.mobilityCategory.getAll).then(({ data }) => {
      const normalized = normalize(data, this.schemaMobilityOptionCategoriesResponse)
      if (!normalized.entities || !normalized.entities.mobilityOptionCategories) {
        return {}
      }
      return normalized.entities.mobilityOptionCategories
    })
  }

  // TODO: Implement service
  public removeCategory(id: string) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(id)
      }, 100)
    })
  }

  // TODO: Implement service
  public createCategory(name: string) {
    const id = new Date().getTime() / 1000
    const obj = { name, id }
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(obj)
      }, 100)
    })
  }

  public createMobilityOption(option: IMobilityOptionObject) {
    return serverApi.post(Paths.mobility.create, option).then(({ data }) => {
      return data
    })
  }

  public updateMobilityOption(option: IMobilityOptionObject) {
    return serverApi.put(Paths.mobility.create, option).then(({ data }) => {
      return data
    })
  }

  public removeMobilityOption(option: IMobilityOptionObject) {
    return serverApi.delete(Paths.mobility.remove + '/' + option.id).then(({ data }) => {
      return data
    })
  }
}

const mobilityOptionsService = new MobilityOptionsService()

export { mobilityOptionsService }



// WEBPACK FOOTER //
// ./src/services/MobilityOption.ts